import isNil from 'lodash/isNil'
import React from 'react'

import TypeString from '#/components/FormatCell/Types/string'

const TypeEnum = ({ value, bold }) => {
  if (isNil(value)) return <span>-</span>

  return <TypeString value={value?.text} bold={bold} />
}
export default TypeEnum
